(() => {
  /* kl24-deck-score-v2 — empty state server-rendered; JS only upgrades when meta data exists */
  const parseSku = (sku) => {
    const match = /^PM-([A-Z0-9]+)-(\d+)-(\d+)-/i.exec(String(sku || '').trim());
    if (!match) return null;
    let setCode = match[1].toUpperCase();
    if (setCode.includes('RSV') || setCode.includes('WHITE')) {
      setCode = 'WHT';
    }
    return {
      setCode,
      cardNumber: `${Number.parseInt(match[2], 10)}/${match[3]}`,
    };
  };

  const normalizeNumber = (value) => {
    const raw = String(value || '').trim();
    if (!raw.includes('/')) return raw.toUpperCase();
    const [left, right] = raw.split('/');
    const leftNum = Number.parseInt(left, 10);
    return `${Number.isNaN(leftNum) ? left : leftNum}/${right}`;
  };

  const typeFallbackNote = (energyType) => {
    const key = String(energyType || '').toLowerCase().trim();
    const map = {
      psycho: 'Starke Tech-Karte für aktuelle Psycho-Zusammenstellungen im Competitive-Bereich.',
      feuer: 'Relevante Option für Feuer-Archetypen und Aggro-Listen im Turnier-Meta.',
      wasser: 'Beliebter Baustein in Wasser-Decks und kontrollierten Meta-Listen.',
      elektro: 'Flexible Tech-Wahl für Elektro- und Accelerate-Strategien.',
      pflanze: 'Solider Support für Pflanzen- und Ramp-Archetypen.',
      kampf: 'Starker Slot für Kampf- und Hit-and-Run-Decks.',
      finsternis: 'Wichtige Ergänzung für Finsternis- und Control-Varianten.',
      metall: 'Staple-Potenzial in Metall- und Item-heavy-Listen.',
      fee: 'Tech-Option für Fee- und Combo-orientierte Decks.',
      drache: 'Hoher Impact in Drachen- und Late-Game-Strategien.',
      farblos: 'Universell einsetzbar in vielen Meta- und Support-Slots.',
    };
    return map[key] || 'Relevante Einzelkarte für aktuelle Turnier- und Meta-Listen.';
  };

  const META_LABEL_NOTE =
    'Vorkommen in Top-Listen. Keine Spielgarantie — Meta kann sich ändern.';

  const buildInlineFootSource = () => `
    <div class="tcg-deck-score-banner__source tcg-deck-score-banner__source--inline-foot">
      <p class="tcg-deck-score-banner__source-inline">
        <a class="tcg-deck-score-banner__source-link" href="https://limitlesstcg.com/tournaments" target="_blank" rel="noopener noreferrer">Limitless TCG</a>
        <span class="tcg-deck-score-banner__source-sep" aria-hidden="true">·</span>
        <span class="tcg-deck-score-banner__source-cockpit">Auswertung Kartenladen24-Cockpit</span>
        <span class="tcg-deck-score-banner__source-sep" aria-hidden="true">·</span>
        <span class="tcg-deck-score-banner__source-date"><span data-deck-meta-date-placeholder>Stand: …</span></span>
      </p>
    </div>
  `;

  const SOURCE_DISCLAIMER_FULL = `
    <div class="tcg-deck-score-banner__source tcg-deck-score-banner__source--full">
      <p class="tcg-deck-score-banner__source-line tcg-deck-score-banner__source-line--primary">
        <span class="tcg-deck-score-banner__source-label">Quelle:</span>
        <a class="tcg-deck-score-banner__source-link" href="https://limitlesstcg.com/tournaments" target="_blank" rel="noopener noreferrer">Limitless TCG</a>
        · Auswertung Kartenladen24-Cockpit
      </p>
      <p class="tcg-deck-score-banner__source-line tcg-deck-score-banner__source-line--muted">
        Meta-Anteil = Vorkommen in ausgewerteten Top-Turnier-Decklisten. Keine Spielgarantie — Meta ändert sich mit Rotation und Bannlisten.
      </p>
      <p class="tcg-deck-score-banner__source-line tcg-deck-score-banner__source-line--date"><span data-deck-meta-date-placeholder>Stand: …</span></p>
    </div>
  `;

  const formatUpdatedAt = (iso) => {
    if (!iso) return '';
    const parsed = new Date(iso);
    if (Number.isNaN(parsed.getTime())) return '';
    return parsed.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const applyMetaUpdatedDates = (iso) => {
    const label = formatUpdatedAt(iso);
    if (!label) return;
    document.querySelectorAll('[data-deck-meta-date-placeholder]').forEach((node) => {
      if (node.textContent.includes('…')) {
        node.textContent = `Stand: ${label}`;
      }
    });
  };

  const TROPHY_ICON_SVG = `<svg class="tcg-deck-score-banner__icon-svg" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 21h8M12 17v4M7 4h10l1 5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4l1-5z"/><path d="M7 4H5a2 2 0 0 0 0 4h2M17 4h2a2 2 0 0 1 0 4h-2"/></svg>`;

  const buildBodyText = (entry) => {
    const usage = entry.usage_percent;
    const archetype = entry.archetype;
    const tier = entry.tier_label;
    if (usage && archetype) {
      return tier ? `${tier} im ${archetype}.` : `Relevant für ${archetype}.`;
    }
    if (usage) {
      return entry.note || 'Aktuell relevant in Top-Turnier-Decklisten.';
    }
    if (entry.note) {
      return entry.note;
    }
    return '';
  };

  const finalizeEmptyState = (root) => {
    const mount = root.querySelector('[data-deck-score-mount]');
    if (mount) mount.hidden = true;
    const empty = root.querySelector('[data-deck-score-empty]');
    if (empty) empty.hidden = false;
    root.dataset.hasStatic = 'true';
    root.classList.remove('tcg-deck-score-banner--async', 'tcg-deck-score-banner--empty-candidate');
  };

  const showEmptyState = (root) => {
    finalizeEmptyState(root);
  };

  const renderMediaColumn = (root, entry) => {
    const usage = entry.usage_percent;

    root.innerHTML = `
      <div class="tcg-deck-score-banner__inner tcg-deck-score-banner__inner--media">
        <h3 class="tcg-deck-score-banner__heading tcg-deck-score-banner__heading--media">Turnier- &amp; Meta-Analyse</h3>
        <div class="tcg-deck-score-banner__media-body">
          <div class="tcg-deck-score-banner__stat-card" aria-label="${usage} Prozent Meta-Anteil. ${META_LABEL_NOTE}">
            <span class="tcg-deck-score-banner__icon">${TROPHY_ICON_SVG}</span>
            <div class="tcg-deck-score-banner__stat-main">
              <p class="tcg-deck-score-banner__percent">
                <span class="tcg-deck-score-banner__percent-value">${usage}</span><span class="tcg-deck-score-banner__percent-suffix">%</span>
              </p>
              <div class="tcg-deck-score-banner__stat-meta">
                <p class="tcg-deck-score-banner__percent-label">Meta-Anteil</p>
                <p class="tcg-deck-score-banner__percent-label-note">${META_LABEL_NOTE}</p>
              </div>
            </div>
          </div>
          ${buildInlineFootSource()}
        </div>
      </div>
    `;
    root.dataset.hasStatic = 'true';
    root.classList.remove('tcg-deck-score-banner--async');
  };

  const renderBanner = (root, entry) => {
    const energyType = root.dataset.energyType || '';
    const note = entry.note || typeFallbackNote(energyType);
    const bodyText = buildBodyText(entry);
    const usage = entry.usage_percent;

    root.innerHTML = `
      <div class="tcg-deck-score-banner__inner">
        <div class="tcg-deck-score-banner__stat">
          <span class="tcg-deck-score-banner__icon">${TROPHY_ICON_SVG}</span>
          ${
            usage
              ? `<p class="tcg-deck-score-banner__percent">
                  <span class="tcg-deck-score-banner__percent-value">${usage}</span><span class="tcg-deck-score-banner__percent-suffix">%</span>
                </p>
                <p class="tcg-deck-score-banner__percent-label">Meta-Match</p>`
              : ''
          }
        </div>
        <div class="tcg-deck-score-banner__content">
          <h2 class="tcg-deck-score-banner__heading">Turnier- &amp; Meta-Analyse</h2>
          ${bodyText ? `<p class="tcg-deck-score-banner__text">${bodyText}</p>` : ''}
          ${note && note !== bodyText ? `<p class="tcg-deck-score-banner__note">${note}</p>` : ''}
          ${SOURCE_DISCLAIMER_FULL}
        </div>
      </div>
    `;
    root.dataset.hasStatic = 'true';
    root.classList.remove('tcg-deck-score-banner--async');
  };

  const renderCompact = (root, entry) => {
    const mount = root.querySelector('[data-deck-score-mount]');
    if (!mount) return;
    mount.hidden = false;
    mount.innerHTML = `
      <span class="tcg-deck-score__label">Deck-Score</span>
      ${
        entry.usage_percent
          ? `<p class="tcg-deck-score__usage">Wird in ca. <strong>${entry.usage_percent}%</strong> der Top-Turnier-Decks gespielt.</p>`
          : ''
      }
      ${
        entry.archetype
          ? `<p class="tcg-deck-score__archetype">${entry.tier_label ? `${entry.tier_label} im` : 'Relevant für'} <strong>${entry.archetype}</strong></p>`
          : ''
      }
      ${entry.note ? `<p class="tcg-deck-score__note">${entry.note}</p>` : ''}
    `;
    root.dataset.hasStatic = 'true';
  };

  const placeholders = document.querySelectorAll('[data-deck-meta-date-placeholder]');
  const roots = document.querySelectorAll('[data-tcg-deck-score]:not([data-has-static])');
  if (!roots.length && !placeholders.length) return;

  const loadScores = async () => {
    const scoresUrl = document.querySelector('[data-deck-scores-url]')?.getAttribute('data-deck-scores-url');
    if (!scoresUrl) return {};
    const response = await fetch(scoresUrl);
    if (!response.ok) return {};
    return response.json();
  };

  const processRoots = (scores) => {
    applyMetaUpdatedDates(scores._updated_at);

    roots.forEach((root) => {
      const section = root.closest('[data-tcg-deck-score-section]');
      const fromSku = parseSku(root.dataset.sku);
      let setCode = (root.dataset.setCode || '').toUpperCase();
      let cardNumber = normalizeNumber(root.dataset.cardNumber || '');
      if (fromSku) {
        setCode = fromSku.setCode;
        cardNumber = fromSku.cardNumber;
      } else if (setCode.includes('RSV') || setCode.includes('WHITE')) {
        setCode = 'WHT';
      }

      const emptyFallback = root.dataset.emptyFallback === 'true';

      if (!setCode || !cardNumber) {
        if (emptyFallback) {
          finalizeEmptyState(root);
          return;
        }
        if (section) section.remove();
        else root.remove();
        return;
      }

      let key = `${setCode}|${cardNumber}`;
      let entry = scores[key];
      if (key.startsWith('_')) entry = undefined;
      if (!entry && fromSku) {
        key = `${fromSku.setCode}|${fromSku.cardNumber}`;
        entry = scores[key];
      }
      if (!entry || !entry.usage_percent) {
        if (emptyFallback) {
          finalizeEmptyState(root);
          return;
        }
        if (section) section.remove();
        else root.remove();
        return;
      }

      const layout = root.dataset.layout || 'compact';
      if (layout === 'banner') {
        renderBanner(root, entry);
      } else if (layout === 'media-column') {
        renderMediaColumn(root, entry);
      } else {
        renderCompact(root, entry);
      }
    });

    applyMetaUpdatedDates(scores._updated_at);
  };

  loadScores()
    .then(processRoots)
    .catch(() => {
      roots.forEach((root) => {
        if (root.dataset.emptyFallback === 'true') finalizeEmptyState(root);
      });
    });
})();
